<tec-modal [isVisible]="isVisible" [title]="titleKey | translate" (closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="(hasActiveRecording ? descriptionWithRecordingKey : descriptionKey) | translate"></span>
		<tec-qr [url]="url" />
	</ng-container>
</tec-modal>
